module.exports = __webpack_public_path__ + "img/901026899.3aac1aef.png";